var _defs, _rect, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.3 307.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke-dasharray: 1.01 1.01;\n      }\n\n      .st1, .st2 {\n        stroke: #ed1c24;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.79,22.65c-6.01,29.68-16.71,61.71-7.44,91.73,7.45,24.12,16.55,47.39,18,72.87,2.4,42.08-6.54,55.81-9.13,97.41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49.15,
    y1: 143.19,
    x2: 49.15,
    y2: 143.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 49.15,
    y1: 144.7,
    x2: 49.15,
    y2: 226.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49.15,
    y1: 227.38,
    x2: 49.15,
    y2: 227.88
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.91,
    y1: 143.97,
    x2: 215.91,
    y2: 144.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 215.91,
    y1: 145.48,
    x2: 215.91,
    y2: 227.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.91,
    y1: 228.16,
    x2: 215.91,
    y2: 228.66
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.11,22.65c6.01,29.68,16.71,61.71,7.44,91.73-7.45,24.12-16.55,47.39-18,72.87-2.4,42.08,6.54,55.81,9.13,97.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations18);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-18.d810275634c82bf6f7c3fbaae0474e1e.svg";
export { ForwardRef as ReactComponent };